import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';
import { CustomFieldError } from '@/common/types';

interface Params {
  customFieldErorrs?: CustomFieldError;
  hideField?: {
    email?: boolean;
    phone?: boolean;
  };
}

const PHONE_TYPES = {
  HOME: 'HOME',
  WORK: 'WORK',
  CELL: 'MOBILE',
  UNKNOWN: 'UNKNOWN',
};
export default ({ hideField, customFieldErorrs }: Params) => {
  const fields = useMemo<Field[]>(
    () => [
      ...(!hideField?.email
        ? ([
            {
              name: 'email',
              type: FieldTypes.Email,
              label: 'Personal email',
              showRequireIcon: true,
              placeholder: 'Enter email',
              validator: VALIDATORS.EMAIL_REQUIRED,
            },
          ] as Field[])
        : []),

      ...(!hideField?.phone
        ? ([
            {
              name: 'phone',
              type: FieldTypes.PhoneNumber,
              label: 'Phone',
              showRequireIcon: true,
              value: ' ',
              placeholder: '+1',
              validator: customFieldErorrs?.phone
                ? VALIDATORS.REQUIRED_STRING.test({
                    test: (val) => val !== customFieldErorrs?.phone?.value,
                    message: customFieldErorrs?.phone?.message,
                  })
                : VALIDATORS.PHONE_NUMBER,
            },
          ] as Field[])
        : []),
    ],
    [customFieldErorrs, hideField]
  );

  return fields;
};
